import React, { useState } from 'react';
import BackButton from './BackButton';
import TreasuryImage from './images/Icon_Gold.png'

function TreasuryMetrics({ totalAssets, formattedTotalValue }) {

    return (
                <div className="inventory-container-right" id="treasury-right">
                    <div className="treasury-header"><img src={TreasuryImage}/><h2>Treasury Metrics</h2><p>Total treasury metrics</p></div>
                    <div className="treasury-stats" id="metrics">
                        <div className="stats-container" id="stats-small"><h3>24H</h3><h2>0%</h2></div>
                        <div className="stats-container" id="stats-small"><h3>30D</h3><h2>0%</h2></div>
                        <div className="stats-container" id="stats-small"><h3>Year</h3><h2>0%</h2></div>
                        <div className="stats-container"><h3>Number of assets</h3><h2>{(totalAssets)}</h2></div>
                        <div className="stats-container"><h3>Treasury Total Value</h3><h2>${(formattedTotalValue)}</h2></div>
                        </div>
                        <div className="stats-container2"><h2></h2></div>
                </div>
      );
    }
    
    export default TreasuryMetrics;